export class CreateEnquiryRequestDTO {
    constructor(
        public firstName: string,
        public lastName: string,
        public emailAddress: string,
        public phoneNumber: string,
        public partySize: number,
        public date: string,
        public time: string,
        public message: string | null
    ) { }
}
